import { Dialog, DialogBody, Typography } from "@material-tailwind/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";

export interface SafetyDiagImageModalProps {
  open: boolean;
  onClose: () => void;
  imageUrl: string;
  alt: string;
  title?: string;
}

/**
 * Modal to display an enlarged view of a safety-diag media capture or signature.
 */
export default function SafetyDiagImageModal({
  open,
  onClose,
  imageUrl,
  alt,
  title,
}: SafetyDiagImageModalProps) {
  const { t } = useTranslation("common");

  return (
    <Dialog
      size="lg"
      open={open}
      handler={onClose}
      className="bg-white max-h-[90vh] overflow-hidden rounded-xl shadow-2xl p-0 flex flex-col"
    >
      <div className="flex items-center justify-between border-b border-gray-100 px-5 py-3 bg-white">
        <Typography variant="h6" className="text-sm font-medium text-gray-800 truncate pr-4">
          {title || alt}
        </Typography>
        <button
          type="button"
          onClick={onClose}
          className="rounded-lg p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition-colors"
          aria-label={t("close", { defaultValue: "Fermer" })}
        >
          <XMarkIcon className="h-5 w-5" />
        </button>
      </div>
      <DialogBody className="p-4 flex items-center justify-center max-h-[80vh] overflow-auto bg-gray-50/50">
        <img
          src={imageUrl}
          alt={alt}
          className="max-h-[75vh] w-auto max-w-full object-contain rounded-lg cursor-zoom-out shadow-sm"
          onClick={onClose}
        />
      </DialogBody>
    </Dialog>
  );
}
